export default __webpack_public_path__ + "static/media/site-icon.6a21f8fc.svg";